import React from "react";
import intl from "react-intl-universal";


import {DeleteWithNameConfirm} from "../components/DeleteWithNameConfirm/DeleteWithNameConfirm";
import {deleteWorkspace} from "../../../../actions/workspace/deleteWorkspace";
import {selectWorkspaceFromPlain} from "../../../../actions/ui/selectWorkspace";
import {useAppState, useAuthService, useDataClientService} from "@stores/AppStateContext";

import {PAGES} from "@stores/ViewStore";
import {DeleteWorkspaceProps} from "../modal-names";


import "./WorkspaceConfirmeDelete.css";


export const WorkspaceConfirmDelete = (
    {wsDB}: DeleteWorkspaceProps
) => {
    const appState = useAppState();
    const rootStore = appState.rootStore;
    const userState = appState.userState!;
    const dsManager = userState.dsManager!;
    const authService = useAuthService();
    const dataClients = useDataClientService();

    const targetWorkspace = dsManager?.workspacesDS.getWorkspaceById(wsDB.id);
    if (!targetWorkspace) {
        return 'Workspace not found';
    }
    const wsName = targetWorkspace.name!;

    const handleConfirm = async () => {
        if (rootStore.view.workspace?.id === wsDB.id) {
            const nextAvailableWs = userState?.availableWorkspaces.filter(ws => ws.id !== wsDB.id);
            selectWorkspaceFromPlain(rootStore, dsManager, nextAvailableWs && nextAvailableWs.length ? nextAvailableWs[0] : null);
            rootStore.view.openPageByName(PAGES.KNOWLEDGE_BASE);
        }
        await deleteWorkspace(dataClients, authService, userState, wsDB);
        appState.setModal(null);
    };

    return (
        <DeleteWithNameConfirm
            header={intl.get('workspaceConfirmDelete.title').d('Delete workspace')}
            confirmText={intl.get('workspaceConfirmDelete.button').d('Delete Workspace')}
            expectedValue={wsName}
            onConfirm={handleConfirm}
            onClose={() => appState.setModal(null)}
            text={
                <>
                    <div>{intl.get('workspaceConfirmDelete.text.firstPart').d('Deleting this workspace will permanently erase all related data and cannot be reversed.')}</div>
                    <br/>
                    <div>{intl.get('workspaceConfirmDelete.text.secondPart').d('To confirm, please enter the name of the workspace.')}</div>
                </>
            }
            />
    )
}
